export default {
  name: 'ExampleComponent',
  data() {
    return {
      header: 'Seems works',
    }
  },
  mounted() {},
}
